import axios from "axios";
import { SessionStore } from "../../types/store/SessionStore";
import { newAbortSignal } from "../../utils";
import { ProjectFile } from "../../types/model/file";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/files`;

export const getFiles = async (
  accountId: number,
  projectId?: number,
  activityId?: number,
  procedureId?: number
): Promise<ProjectFile[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  const finalURL = `${BASE_URL}`;

  const response = await axios.get<ProjectFile[]>(finalURL, {
    headers: {
      "Content-Type": "application/json",
      "x-access-token": session?.accessToken,
    },
    params: {
      accountId,
      projectId,
      activityId,
      procedureId
    },
    timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      typeof AbortSignal.timeout !== "undefined"
        ? AbortSignal.timeout(
            parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
          )
        : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
  });

  return response.data;
};
